<template>
    <div class="page-roadmap-to-success">
        <div class="jumbo-wrapper roadmap-to-success">
            <div class="jumbo-main">
                <div class="jumbo-content">
                    <p class="t15">ROADMAP TO SUCCESS</p>
                    <h2 class="t42">
                        STEP-BY-STEP
                        <br/>
                        PROJECT GUIDE
                    </h2>
                    <p class="t20">We’ve broken down what you need.</p>
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="box-content-inner">
                <div class="row checkbox-list">
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            EVERYTHING YOU NEED
                            <br/>
                            AT YOUR FINGERTIPS
                        </p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            FREE PRODUCT GRAPHICS
                            <br/>
                            FOR YOUR MARKETING
                        </p>
                    </div>
                    <div class="col-sm-6 col-xs-12 col-md-4 text-center">
                        <div class="icon-box">
                            <img src="images/checkbox.png" alt="">
                        </div>
                        <p class="heading">
                            TIPS, TRICKS &amp; EXTRAS TO
                            <br/>
                            CUSTOMIZE YOUR PROJECT
                        </p>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            SUCCESS IN 6 STEPS!
                        </h6>
                        <p>
                            Our Roadmap to Success breaks down
                            the entire process of an Engraved Brick
                            Project into 6 steps, from conception
                            through installation. We guide you
                            through your options, what you need,
                            and when. Our goal is to make the
                            process easy to manage and as
                            streamlined as possible.
                        </p>
                    </div>
                    <div class="body-area-right">
                        <img width="450" height="298" class="img-responsive" src="images/Roadmap-To-Success/roadmaptosuccess01.png" alt="">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <img width="450" height="298" class="img-responsive" src="images/Roadmap-To-Success/roadmaptosuccess02.png" alt="">
                    </div>
                    <div class="body-area-right">
                        <h6 class="body-area-headline">
                            FREE ENGRAVED BRICK SAMPLE
                            FOR DISPLAY & MARKETING
                        </h6>
                        <p>
                            Displaying a brick helps donors envision
                            their own brick and message which builds
                            excitement.
                        </p>
                        <ul class="body-area-list probe">
                            <li><span>Your Personalized Inscription</span></li>
                            <li><span>Sample in Your Chosen Material(s)</span></li>
                            <li><span>Display at Your Facility or Booth</span></li>
                        </ul>
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <h6 class="body-area-headline">
                            FREE RESOURCES
                        </h6>
                        <p>
                            Our Roadmap includes an extensive
                            reference section which provides additional
                            information to create a complete
                            fundraising solution
                        </p>
                        <ul class="body-area-list">
                            <li><span>Marketing Templates</span></li>
                            <li><span>Digital Asset Library</span></li>
                            <li><span>Installation &amp; Layout Examples</span></li>
                            <li><span>Project Companion</span></li>
                            <li><span>Checklists</span></li>
                            <li><span>... and More!</span></li>
                        </ul>
                    </div>
                    <div class="body-area-right">
                        <img width="450" height="401" class="img-responsive" src="images/Roadmap-To-Success/roadmaptosuccess03.png" alt="">
                    </div>
                </div>

                <hr class="frl-hr"/>

                <div class="body-area">
                    <div class="body-area-left">
                        <img width="450" height="356" class="img-responsive" src="images/Roadmap-To-Success/roadmaptosuccess04.png" alt="">
                    </div>
                    <div class="body-area-right">
                        <h6 class="body-area-headline">
                            TIPS &amp; TRICKS
                        </h6>
                        <p>
                            Compiled from our 32+ years in the
                            industry, each step includes ways to
                            take your project to the next level and
                            customize it for your organization and
                            donors.
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    export default {
        name: 'roadmap-to-success',
        components: {
        },
        metaInfo: {
            title: 'Roadmap to Success',
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: ''
                }
            ]
        }
    }
</script>




// WEBPACK FOOTER //
// RoadmapToSuccess.vue?c124f496